import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



export interface errors {
  status: string;
  sku: string;
  description: string;
}
@Component({
  selector: 'app-charging-modal',
  templateUrl: './charging-modal.component.html',
  styleUrls: ['./charging-modal.component.scss']
})
export class ChargingModalComponent implements OnInit, OnDestroy {

  dataRecieved: any ;
  readonly modals =
    [{
        img: 'assets/image/modal/icon-file-success.svg',
        title: 'Un momento por favor... <br> estamos actualizando los precios de tu pedido',
        description: 'Esto puede tardar unos minutos.',
       
      },
      {
        img: 'assets/image/modal/icon-file-success.svg',
        title: 'Estamos cargando tu lista de productos',
        description: 'Esto puede tardar algunos minutos.',
       
      }
    ]
  constructor(
    public readonly dialogRef: MatDialogRef<ChargingModalComponent>,
    private readonly renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) data
    ) {
      this.openedStart()
      this.dataRecieved = data;
    
    }
  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this.closedStart()
  }


  save(status, message){
    this.dialogRef.close({status:status, message: message});
  }
  onNoClick(){
    this.dialogRef.close(false);
  }
  
  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
  exit(){
    this.dialogRef.close();
  }

}
